function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import { rootKey } from '../util';

var RegisteredParticipant = /*#__PURE__*/function (_Base) {
  _inheritsLoose(RegisteredParticipant, _Base);

  function RegisteredParticipant() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = RegisteredParticipant.prototype;

  _proto.initialize = function initialize(opts) {
    if (opts == null) {
      opts = {};
    }

    if (opts.user) {
      // Disregard the id for the saved model
      opts.user.unset('id');
      return this.set(opts.user.attributes);
    }
  };

  _proto.url = function url() {
    return '/users';
  };

  _proto.toJSON = function toJSON() {
    return rootKey('user', this.pick(this.modelProperties));
  };

  _proto.isLoggedIn = function isLoggedIn() {
    return this.id > 0;
  };

  _proto.isOnlyRegParticipant = function isOnlyRegParticipant() {
    return !this.get('account_id');
  };

  _createClass(RegisteredParticipant, [{
    key: "defaults",
    get: function get() {
      return {
        role: 'participant'
      };
    }
  }, {
    key: "modelProperties",
    get: function get() {
      return ['id', 'email', 'first_name', 'last_name', 'password', 'role', 'user_source'];
    }
  }]);

  return RegisteredParticipant;
}(Base);

export { RegisteredParticipant as default };